module.exports = __webpack_public_path__ + "static/media/logo.news-index.5c54e046.png";